import { render, staticRenderFns } from "./InfoFile.vue?vue&type=template&id=79a4509e&scoped=true"
import script from "./InfoFile.vue?vue&type=script&lang=js"
export * from "./InfoFile.vue?vue&type=script&lang=js"
import style0 from "./InfoFile.vue?vue&type=style&index=0&id=79a4509e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a4509e",
  null
  
)

export default component.exports